export default __webpack_public_path__ + "static/media/misc-pantry3-1024w.d0ca8930.avif";